import React from 'react';

const FileInvoiceIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.83333 4C8.27057 4 7 5.34531 7 7V25C7 26.6547 8.27057 28 9.83333 28H21.1667C22.7294 28 24 26.6547 24 25V11.5H18.3333C17.5497 11.5 16.9167 10.8297 16.9167 10V4H9.83333ZM18.3333 4V10H24L18.3333 4ZM9.83333 7.75C9.83333 7.3375 10.1521 7 10.5417 7H13.375C13.7646 7 14.0833 7.3375 14.0833 7.75C14.0833 8.1625 13.7646 8.5 13.375 8.5H10.5417C10.1521 8.5 9.83333 8.1625 9.83333 7.75ZM9.83333 10.75C9.83333 10.3375 10.1521 10 10.5417 10H13.375C13.7646 10 14.0833 10.3375 14.0833 10.75C14.0833 11.1625 13.7646 11.5 13.375 11.5H10.5417C10.1521 11.5 9.83333 11.1625 9.83333 10.75Z" fill="#B5B8BF"/>
  </svg>
);

export default FileInvoiceIcon;
